import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

// Masked line-by-line reveal (hero signature moment)
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="mask-line">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, ease, delay }}
    >
      {children}
    </motion.span>
  </span>
);

// Scroll-triggered fade/rise
export const Reveal = ({ children, delay = 0, y = 32, className = "", as = "div" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const M = motion[as] || motion.div;
  return (
    <M
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, ease, delay }}
    >
      {children}
    </M>
  );
};

// Reveal that reads a line by line (for section headings)
export const RevealLine = ({ children, delay = 0, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <span ref={ref} className="mask-line">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={inView ? { y: 0 } : {}}
        transition={{ duration: 0.9, ease, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
};
